// Room Image Slider
document.addEventListener('DOMContentLoaded', () => {
  const roomSlides = document.querySelectorAll('.rooms-slider .room-slide');

  roomSlides.forEach((roomSlide) => {
    const imagesWrapper = roomSlide.querySelector('.room-images-wrapper');
    if (!imagesWrapper) return;

    const imagesContainer = imagesWrapper.querySelector('.room-images');
    const images = imagesContainer ? Array.from(imagesContainer.querySelectorAll('img')) : [];
    const prevButton = imagesWrapper.querySelector('.room-image-prev');
    const nextButton = imagesWrapper.querySelector('.room-image-next');
    const dots = imagesWrapper.querySelectorAll('.room-image-dot');

    if (images.length <= 1) return;

    let currentImageIndex = 0;

    // Add orientation classes to images
    images.forEach((img) => {
      // Function to check orientation and add class
      const setOrientationClass = () => {
        const width = img.naturalWidth || img.width;
        const height = img.naturalHeight || img.height;

        if (width > height) {
          img.classList.add('landscape');
          img.classList.remove('portrait');
        } else {
          img.classList.add('portrait');
          img.classList.remove('landscape');
        }
      };

      // Check if image is already loaded
      if (img.complete && img.naturalWidth) {
        setOrientationClass();
      } else {
        // Wait for image to load
        img.addEventListener('load', setOrientationClass);
      }
    });

    // Show the first image
    images[0].classList.add('active');

    // Function to update the active image
    const showImage = (index) => {
      // Remove active class from all images
      images.forEach((img) => img.classList.remove('active'));

      // Add active class to the current image
      images[index].classList.add('active');

      // Update dots
      dots.forEach((dot, i) => {
        if (i === index) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });

      currentImageIndex = index;
    };

    // Previous button
    if (prevButton) {
      prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        let newIndex = currentImageIndex - 1;
        if (newIndex < 0) {
          newIndex = images.length - 1; // Loop to last image
        }
        showImage(newIndex);
      });
    }

    // Next button
    if (nextButton) {
      nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        let newIndex = currentImageIndex + 1;
        if (newIndex >= images.length) {
          newIndex = 0; // Loop to first image
        }
        showImage(newIndex);
      });
    }

    // Dot navigation
    dots.forEach((dot) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const index = parseInt(dot.getAttribute('data-index'));
        if (!isNaN(index)) {
          showImage(index);
        }
      });
    });

    // Initialize button states
    showImage(0);
  });
});
